export { TURN_TIMES } from '@customink/project-service-types';
/* Phone numbers */
export const CustomerCareNumber = '800-293-4232';

/* Liveperson */
export const LivePersonId = import.meta.env.PROJECT_SERVICE_LIVEPERSON_ID;
export const LivePersonTaxExemptId = import.meta.env
  .PROJECT_SERVICE_LIVEPERSON_TAX_EXEMPT_ID;

/* Error Messages */
export const zipCodeErrorMessage = 'Please enter a valid zip/postal code.';
export const voucherNotFoundErrorMessage = 'Voucher not found.';
export const invalidVoucherErrorMessage =
  'Not a valid voucher code for this order.';

/* Google Analytics */
export const GA_EVENTS = {
  REMOVE_FROM_CART: 'remove_from_cart',
  VIEW_CART: 'view_cart',
} as const;
export type GA_EVENT_NAME = (typeof GA_EVENTS)[keyof typeof GA_EVENTS];

// used for quantity types for GA3
export const ORDER_TYPES = {
  SINGLES: 'singles',
  MIXED: 'mixed',
  BULK: 'bulk',
  REORDER: 'reorder',
} as const;

export const LOGIN_URL =
  import.meta.env.PROJECT_SERVICE_CI_HOSTNAME + '/oauth/authenticate';

export const WCIBMO_NAMES = {
  CANADA_PRODUCT_TO_US: 'canada_product_to_us',
  ENTER_QUANTITIES: 'enter_quantities',
  INVALID_ZIP_CODE: 'invalid_shipping_postal_code',
  RAISE_ABOVE_MIN: 'raise_quantity_above_minimum',
  RAISE_ABOVE_MIN_OR_STYLE:
    'raise_quantity_above_minimum_or_change_to_alternate_style',
  RAISE_ABOVE_MIN_OR_PRODUCT:
    'raise_quantity_above_minimum_or_change_to_alternate_product',
  RAISE_ABOVE_HIGH_COLOR_MIN: 'raise_quantity_above_high_color_min',
  RAISE_ABOVE_HIGH_COLOR_MIN_OR_PRODUCT:
    'raise_quantity_above_high_color_min_or_change_to_alternate_product',
  RAISE_ABOVE_HIGH_COLOR_MIN_OR_STYLE:
    'raise_quantity_above_high_color_min_or_change_to_alternate_style',
  US_PRODUCT_TO_CANADA: 'us_product_to_canada',
  RAISE_ABOVE_MIN_OR_REMOVE_SLEEVE:
    'raise_quantity_above_minimum_or_remove_sleeve',
} as const;
export type WCIBMO_NAME = (typeof WCIBMO_NAMES)[keyof typeof WCIBMO_NAMES];

export const HIGH_COLOR_DESIGN_MIN_ORDER_QUANTITY = 48;
export const HIGH_COLOR_DESIGN_COLOR_COUNT = 5;
export const SLEEVE_VIEW_NAMES = ['left_sleeve', 'right_sleeve'];
export const SLEEVE_VIEW_PRESENT_MIN_QUANTITY = 6;
